module.exports = __webpack_public_path__ + "static/postKreatif-logo-c4c0397aa73e7321ebc6bde0deb5ada7.png";